import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Eye } from "lucide-react";

const countryFlags: Record<string, string> = {
  US: "🇺🇸", GB: "🇬🇧", CA: "🇨🇦", AU: "🇦🇺", DE: "🇩🇪", FR: "🇫🇷", JP: "🇯🇵", IN: "🇮🇳",
  BR: "🇧🇷", NG: "🇳🇬", ZA: "🇿🇦", KE: "🇰🇪", GH: "🇬🇭", AE: "🇦🇪", SG: "🇸🇬", KR: "🇰🇷",
  MX: "🇲🇽", IT: "🇮🇹", ES: "🇪🇸", NL: "🇳🇱", SE: "🇸🇪", NO: "🇳🇴", DK: "🇩🇰", PL: "🇵🇱",
  TR: "🇹🇷", SA: "🇸🇦", PH: "🇵🇭", MY: "🇲🇾", TH: "🇹🇭", ID: "🇮🇩", PK: "🇵🇰", EG: "🇪🇬",
  CO: "🇨🇴", AR: "🇦🇷", CL: "🇨🇱", PE: "🇵🇪", RO: "🇷🇴", UA: "🇺🇦", VN: "🇻🇳", BD: "🇧🇩",
};

const countryNames: Record<string, string> = {
  US: "United States", GB: "United Kingdom", CA: "Canada", AU: "Australia", DE: "Germany",
  FR: "France", JP: "Japan", IN: "India", BR: "Brazil", NG: "Nigeria", ZA: "South Africa",
  KE: "Kenya", GH: "Ghana", AE: "UAE", SG: "Singapore", KR: "South Korea",
  MX: "Mexico", IT: "Italy", ES: "Spain", NL: "Netherlands", SE: "Sweden", NO: "Norway",
  DK: "Denmark", PL: "Poland", TR: "Turkey", SA: "Saudi Arabia", PH: "Philippines",
  MY: "Malaysia", TH: "Thailand", ID: "Indonesia", PK: "Pakistan", EG: "Egypt",
  CO: "Colombia", AR: "Argentina", CL: "Chile", PE: "Peru", RO: "Romania",
  UA: "Ukraine", VN: "Vietnam", BD: "Bangladesh",
};

const codes = Object.keys(countryFlags);

const VisitorNotification = () => {
  const [notification, setNotification] = useState<{ flag: string; country: string } | null>(null);

  useEffect(() => {
    const showNotification = () => {
      const code = codes[Math.floor(Math.random() * codes.length)];
      setNotification({ flag: countryFlags[code], country: countryNames[code] });
      setTimeout(() => setNotification(null), 4000);
    };

    // First notification after 3 seconds
    const initial = setTimeout(showNotification, 3000);
    // Then every 8-15 seconds
    const interval = setInterval(showNotification, 8000 + Math.random() * 7000);

    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="fixed bottom-24 left-4 z-50 lg:bottom-6">
      <AnimatePresence>
        {notification && (
          <motion.div
            initial={{ opacity: 0, x: -100, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -100, scale: 0.8 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            className="flex items-center gap-3 rounded-xl border border-gold-dark/30 bg-card px-4 py-3 shadow-lg backdrop-blur"
          >
            <span className="text-2xl">{notification.flag}</span>
            <div>
              <div className="flex items-center gap-1.5 text-xs text-muted-foreground font-body">
                <Eye className="h-3 w-3" /> Someone from
              </div>
              <p className="text-sm font-display font-semibold text-foreground">
                {notification.country} <span className="text-gold">is visiting</span>
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default VisitorNotification;
